// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__1mvgB","colMin":"styles_colMin__12aEL","colCheckbox":"styles_colCheckbox__3qxFs"};